module.exports = __webpack_public_path__ + "img/accessory_pants_08.4bd4298e.svg";